export default __webpack_public_path__ + "static/media/02_photo.c9df80a0.jpg";